import './components/Cookiebar'
import './components/DynamicForm'
import './components/FAQ'
import './components/ImageSlider'
import './components/Lightbox'
import { createElement as $ } from './lib/createElement'

declare global {
	const FT: any
}

addEventListener('DOMContentLoaded', () => {
	// ...
	initializeMenu()
	initializeSidemenu()
	// sideMenu()
	reservationButtons()
	hideSidemenu()
	scrolledMenu()
})

function scrolledMenu(){
	const menu = document.getElementById('menu-top')

	if (document.documentElement.scrollTop > 100) {
		menu.classList.add('scrolled')
	}

	window.addEventListener('scroll', ()=> {
		if (document.documentElement.scrollTop > 100) {
			menu.classList.add('scrolled')
		} else {
			menu.classList.remove('scrolled')
		}
	})
}

// Main menu.
function initializeMenu() {
	// Toggler for mobile.
	const hamburgerButton = document.getElementById('hamburger')
	if (hamburgerButton) {
		hamburgerButton.addEventListener('click', function () {
			document.body.classList.toggle('menu-open')
		})
	}
}

function reservationButtons(){
	const btns = document.querySelectorAll('button.btn.reserve')
	btns.forEach((btn) => {
		btn.addEventListener('click', () => {
			FT.widgets.get().openTicket('f0e33651')
		})
	})

	const btnPrestige = document.querySelectorAll('button.btn.reserve.prestige')
	btnPrestige.forEach((btn) => {
		btn.addEventListener('click', () => {
			FT.widgets.get().openTicket('4eff85f3')
		})
	})
}

function initializeSidemenu() {
	type SidemenuChapter = {
		anchor: HTMLAnchorElement
		viewElement: HTMLElement
		range: [number, number]
	}

	// Sidemenu element.
	const sidemenuContent = $('div', { className: 'content' })
	const sidemenu = $('div', { id: 'side-menu' }, sidemenuContent)

	// Collect all the titles.
	const titles = Array.from(document.querySelectorAll('section h2')) // Add h3?
		// Filter out titles that have been placed in an element with the class `no-side-title`.
		.filter(node => {
			while (node = node.parentElement) {
				if (node.classList.contains('no-side-title')) {
					return false
				}
			}
			return true
		})
		// Create sidemenu anchors.
		.map((title, index) => {
			const start = index == 0 ? 0 : title.parentElement.getBoundingClientRect().top
			const anchor = $('a', {
				className: 'heading',
				href: '#' + title.id,
			}, title.textContent.trim())
			sidemenuContent.appendChild(anchor)

			return {
				anchor,
				viewElement: title.parentElement,
				range: [start, 0]
			} as SidemenuChapter
		})
		// Filter out titles that have the same Y position as previous titles.
		.filter((chapter, index, chapters) => {
			return index == 0 || chapters[index - 1].range[0] != chapter.range[0]
		})

	if (titles.length > 1) {
		document.body.appendChild(sidemenu)
	}

	// Recalculate the start and end of each section.
	const calculateRanges = () => {
		for (const [index, { viewElement, range }] of titles.entries()) {
			const start = index == 0 ? 0 : viewElement.getBoundingClientRect().top + scrollY
			const end = index == titles.length - 1
				? document.body.scrollHeight
				: titles[index + 1].viewElement.getBoundingClientRect().top + scrollY // Next element.

			range[0] = Math.floor(start)
			range[1] = Math.floor(end)
		}
	}

	// Update the sidemenu when the user scrolls.
	// We check which segment intersects with the center of the screen.
	const onScroll = () => {
		const centerY = scrollY + (innerHeight / 2)
		for (const { anchor, range } of titles) {
			const isInView = centerY > range[0] && centerY <= range[1]
			anchor.classList.toggle('active', isInView)
		}
	}

	addEventListener('resize', calculateRanges)
	addEventListener('scroll', onScroll, { passive: true })
	addEventListener('load', () => {
		calculateRanges()
		onScroll()
	})

	calculateRanges()
	onScroll()
}

function hideSidemenu(){
	const sidemenu = document.getElementById('side-menu') as HTMLDivElement  || null
	const hero = document.getElementById('hero')

	if(sidemenu){
		window.onscroll = () => {
			sidemenu.classList.toggle('show', document.documentElement.scrollTop > hero.clientHeight / 2)
		}
	}

	
}